import { useEffect, useRef, useState } from 'react'
import { Logo } from '../../../components/logo/Logo'
import { FreeroamService } from '../../../services/FreeroamService'
import { formatNumberByDotPerThousand } from '../../../utils/formatNumberByDotPerThousand'
import { FreeroamDataUpdate } from '../Freeroam'
import './FreeroamHud.css'
import { FreeroamHudItem } from './item/FreeroamHudItem'

interface FreeroamHudProps {
	dataUpdate: FreeroamDataUpdate | null
}

const UPDATE_ANIMATION_TIME = 2200

export const FreeroamHud = ({ dataUpdate }: FreeroamHudProps) => {
	const [money, setMoney] = useState(0)
	const [star, setStar] = useState(0)

	const [moneyUpdate, setMoneyUpdate] = useState("")
	const [starUpdate, setStarUpdate] = useState("")

	const [moneyUpdateId, setMoneyUpdateId] = useState(0)
	const [starUpdateId, setStarUpdateId] = useState(0)

	const moneyTimerRef = useRef<number | null>(null)
	const starTimerRef = useRef<number | null>(null)

	const fetchFreeroamPointData = async () => {
		await FreeroamService.getFreeroamPointData()
			.then((res) => {
				setMoney(res.data.money)
				setStar(res.data.xp)
			})
			.catch((err) => {
				console.log(err)
			})
	}

	useEffect(() => {
		fetchFreeroamPointData()

		return () => {
			if (moneyTimerRef.current) clearTimeout(moneyTimerRef.current)
			if (starTimerRef.current) clearTimeout(starTimerRef.current)
		}
	}, [])

	useEffect(() => {
		if (!dataUpdate) return

		if (dataUpdate.type === "MONEY") {
			setMoney(dataUpdate.newTotal)
			setMoneyUpdate(`+${dataUpdate.amount}$`)
			setMoneyUpdateId(prev => prev + 1)

			if (moneyTimerRef.current) clearTimeout(moneyTimerRef.current)
			moneyTimerRef.current = window.setTimeout(() => {
				setMoneyUpdate("")
			}, UPDATE_ANIMATION_TIME)
		}

		if (dataUpdate.type === "EXPERIENCE") {
			setStar(dataUpdate.newTotal)
			setStarUpdate(`+${dataUpdate.amount}xp`)
			setStarUpdateId(prev => prev + 1)

			if (starTimerRef.current) clearTimeout(starTimerRef.current)
			starTimerRef.current = window.setTimeout(() => {
				setStarUpdate("")
			}, UPDATE_ANIMATION_TIME)
		}

		const sound = new Audio("./sounds/counting.mp3")
		sound.play()
	}, [dataUpdate])

	return (
		<div className='freeroam-hud'>
			<div className='logo-container-wrapper'>
				<Logo type='main' scale={0.75} />
			</div>

			<div className='freeroam-hud-inner-wrapper'>
				<FreeroamHudItem
					icon="coin"
					text={formatNumberByDotPerThousand(money)}
					color="#341733"
					updateAmount={moneyUpdate}
					updateId={moneyUpdateId}
				/>

				<FreeroamHudItem
					icon="star"
					text={formatNumberByDotPerThousand(star)}
					color="#29CDFF"
					updateAmount={starUpdate}
					updateId={starUpdateId}
				/>
			</div>
		</div>
	)
}